// extracted by mini-css-extract-plugin
module.exports = {"title":"SectionGroup_title__b8WTh"};